<template>
<div class="page-container" v-loading="isLoading"> 
  <div class="search-box">
    <div class="flex-row search-main">
      <el-popover
        popper-class="search-popover"
        placement="bottom"
        width="628"
        v-model="showSearchPopover"
        trigger="click">
        <div class="history-popup">
          <div class="search-popver__title">大家都在搜</div>
          <div class="search-popver__content">
            <div class="item" v-for="(item, index) in tags" @click="selectTag(item)" :key="index">{{ item }}</div>
          </div>
          <div class="search-popver__title">
            <span>搜索历史</span>
            <span class="clear-btn" v-if="historyList.length" @click="clearHistoryDialog = true"><i class="el-icon-delete"></i>清除</span>
          </div>
          <div :class="['search-popver__content', 'history-content', historyExpanded ? 'is-expanded' : '']" v-if="historyList.length" ref="historyContent">
            <div class="history-items" ref="historyItems">
              <div class="item" v-for="(item, index) in historyList" @click="historyItemClick(item)" :key="index">{{ item }}</div>
            </div>
            <div class="expand-btn" v-if="historyOverflow && !historyExpanded" @click="historyExpanded = true">
              <i class="el-icon-arrow-down"></i>
            </div>
            <div class="expand-btn" v-if="historyExpanded" @click="historyExpanded = false">
              <i class="el-icon-arrow-up"></i>
            </div>
          </div>
          <div class="search-popver__content" v-else>
            <div class="no-data" style="padding: 0; font-size: 12px;">暂无搜索历史</div>
          </div>
        </div>
        <div class="input-btn flex-row" slot="reference">
          <el-input style="width: 600px;" placeholder="请输入品牌/直播间/品类/商品名称" v-model="keyword" />
          <el-button class="search-btn" @click="toSearch()">搜索</el-button>
        </div>
      </el-popover>
      <el-button @click="downloadHandler" v-loading="isDownloading" :disabled="isDownloading" icon="el-icon-download" class="export-btn">导出数据</el-button>
    </div>
    <div class="tags-box">
      <span class="tag" v-for="tag in tags" :key="tag" @click="selectTag(tag)">{{ tag }}</span>
    </div>
  </div>

  <div class="search-types">
    <div class="type-line type-line1">
      <div :class="['item', item.value === form.categoryId ? 'active' : '']" v-for="(item, index) in categoryList" :key="index"
        @click="categoryClick(item)"
      >{{ item.label }}</div>
    </div>
    <div :class="['type-line type-line2', brandDown ? '' : 'is-down']" >
      <div :class="['item', item.value === form.brandName ? 'active' : '']" v-for="(item, index) in brandList" :key="index"
        @click="form.brandName = item.value; getList()"
      >{{ item.label }}</div>

      <div class="down" @click="brandDown = !brandDown">
        <i v-if="brandDown" class="el-icon-arrow-down"></i>
        <i v-else class="el-icon-arrow-up"></i>
      </div>
    </div>

    <div class="line-tabs">
      <div :class="['item', curSortType === 2 ? 'active' : '']" @click="curSortType = 2; getList()">折扣</div>
      <div :class="['item', curSortType === 3 ? 'active' : '']" @click="curSortType = 3; getList()">最新</div>
    </div>
  </div>

  <div class="cards-container" v-if="list.length && !isLoading">
    <div class="item" v-for="(item, index) in list" :key="index">
      <ProductCard :product="item" :sortType="curSortType"
        @toBuy="toBuy(item)"
        @copy="copyContent(item)" />
    </div>
  </div>
  <div v-else class="no-data">
    暂无数据
  </div>
  <div class="page-pagination">
    <el-pagination
      v-if="pageInfo.total > 0"
      class="d-ib"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total"
      :page-size="pageInfo.pageSize"
      :page-sizes="pageInfo.sizes"
      :current-page="pageInfo.pageIndex"
      @current-change="pageInfo.pageIndex = arguments[ 0 ], getList()"
      @size-change="pageInfo.pageSize = arguments[ 0 ]; pageInfo.pageIndex = 1; getList()">
    </el-pagination>
  </div>

  <!-- 下载提示框 -->
  <BaseDailog v-if="showXlsxDialog" v-model="showXlsxDialog" width="512px" :showCancel="false" @confirm="copyLink"
    title="下载最新口令表格"
    confirmText="点击复制"
    :subTitle="`下载时间：${xlsxInfo.time}`"
  >
    <div class="download-container">
      <div class="down-tip">请复制以下链接，使用浏览器打开，<span class="red">并在10分钟内下载</span>，逾期将自动失效（内部资料，<span class="red">请勿外传，一经发现，终止合作</span>)</div>
      <div>
        <div class="down-title">下载链接：</div>
        <a :href="xlsxInfo.url" target="_blank">{{ xlsxInfo.url }}</a>
      </div>
    </div>
  </BaseDailog>

  <BaseDailog v-if="showCopyDialog" v-model="showCopyDialog" width="512px" :showCancel="false" @confirm="copyKLFn"
    title="复制口令"
    confirmText="点击复制"
  >
    <div v-if="curRow" class="copy-content">
      <div>直播间：{{ curRow.liveRoomName }}</div>
      <div>品类：{{ curRow.categoryName }}</div>
      <div>品牌：{{ curRow.brandName }}</div>
      <div v-if="curRow.h5Show == 1 && curRow.signalPass && curRow.backendCommission">
        <div>失效时间：{{ computedTime(curRow.validEndTime) }}</div>
        <div>口令：{{ extractUrls(curRow.signalPass) }}</div>
        <div>爆品限时补贴至：{{ curRow.userRebateStr || 0 }}</div>
      </div>
      <div v-else style="margin-top: 20px;">
        选品库暂无有效口令。我现在需要，请工作人员尽快安排！谢谢！
      </div>
    </div>
  </BaseDailog>


  <BaseDailog v-if="clearHistoryDialog" v-model="clearHistoryDialog" width="512px" @cancel="showSearchPopover = true; clearHistoryDialog = false;" @confirm="clearHistory" title="提示">
    <div class="clear-content">确定要删除所有历史记录吗？</div>
  </BaseDailog>

  <BuyDrawer v-model="showBuyDrawer" @toOrder="toOrder" :product="curRow" />

  <AddReportDialog
    v-if="showAddReportDialog"
    v-model="showAddReportDialog"
    :roleType="roleType"
    :product="curRow"
    @check-result="checkResultCb"
    @close="showAddReportDialog = false"
    @on-success="showAddResultDialogHandler"
  />

  <!-- 检查结果弹框 -->
  <CheckResultDialog
    v-if="showCheckResultDialog"
    v-model="showCheckResultDialog"
    :rst="checkResult"
    @close="showCheckResultDialog = false" />

  <AddResultDialog
    v-if="showAddResultDialog"
    v-model="showAddResultDialog"
    :importResult="importResult"
    :roleType="roleType"
    @close="showAddResultDialog = false; importResult = {}"
    @on-success="showAddResultDialog = false"
  />

  <WbotIcon />
    
</div>
</template>

<script>
import BaseDailog from '@/page/component/sections/base-dailog'
import ProductCard from '@/page/component/sections/xpk/m2s/product-card'
import BuyDrawer from '@/page/component/sections/xpk/m2s/buy-drawer'
import AddReportDialog from '@/page/component/sections/order/add-report-dialog.vue'
import CheckResultDialog from '@/page/component/sections/order/check-result-dialog.vue'
import AddResultDialog from '@/page/component/sections/order/add-result-dialog.vue'
import WbotIcon from '@/page/component/sections/xpk/wbot-icon.vue'
import { uploadImage, addBuryingPoint } from '@/service/apis/common'
import { getUserId } from '@/utils/getUser'
import { getAccountRoleType } from '@/service/apis/order'
import {
  getKlHotSearchWord,
  queryKlProductCategoryPage,
  getBrandList,
  queryKlLiveRoomProductQdH5Page,
  queryKlLiveRoomProductQdH5List,
  getLoginUserPhone
} from '@/service/apis/kl'
import * as XLSX from 'xlsx'
import moment from 'moment'
import { copyFn } from '@/utils/util'

export default {
  components: {
    BaseDailog,
    ProductCard,
    BuyDrawer,
    AddReportDialog,
    CheckResultDialog,
    AddResultDialog,
    WbotIcon
  },
  name: 'XpkM2s',
  data() {
    return {
      showSearchPopover: false,
      historyList: [],
      clearHistoryDialog: false,
      historyExpanded: false,
      historyOverflow: false,
      keyword: '',
      form: {
        categoryId: '',
        brandName: ''
      },
      hasData: true,
      categoryList: [],
      brandList: [],
      brandDown: true,
      tags: [],
      pageInfo: {
        pageIndex: 1,
        pageSize: 20,
        sizes: [ 10, 20, 30, 50, 100 ],
        total: 0
      },
      list: [],
      curSortType: 2,
      isLoading: false,
      phone: null,
      downLoading: null,
      xlsxInfo: {
        url: '',
        time: ''
      },
      curRow: null,
      showXlsxDialog: false,
      showCopyDialog: false,
      showBuyDrawer: false,
      showAddReportDialog: false,
      roleType: null,
      checkResult: null,
      showCheckResultDialog: false,
      showQueryBdRebateInfoDialog: false,
      showAddResultDialog: false
    }
  },
  watch: {
    showSearchPopover (val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => this.checkHistoryOverflow(), 50)
        })
      }
    }
  },
  async created () {
    await this.getAccountRoleType()
    this.init()
    this.getList()
  },
  methods: {
    getAccountRoleType () {
      const accountId = getUserId()
      getAccountRoleType.call(this, {
        accountId // getUserId()
      }).then(res => {
        if (res) {
          this.roleType = res 
        }
      })
    },
    clearHistory () {
      this.historyList = []
      window.localStorage.setItem('M2S_HISTORY_SEARCH', JSON.stringify(this.historyList))
    
      this.clearHistoryDialog = false
    },
    historyItemClick (tag) {
      this.updateHistoryList(tag)
      this.toSearchPage(tag)
    },
    updateHistoryList (tag) {
      if (this.historyList.includes(tag)) {
        this.historyList = this.historyList.filter(item => item !== tag)
      }
      this.historyList.unshift(tag)
      window.localStorage.setItem('M2S_HISTORY_SEARCH', JSON.stringify(this.historyList))
      this.$nextTick(() => this.checkHistoryOverflow())
    },
    checkHistoryOverflow () {
      const el = this.$refs.historyItems
      if (el) {
        // 每行高度约38px（32px行高 + 6px margin），2行约76px
        this.historyOverflow = el.scrollHeight > 76
      }
    },
    isValid (data) {
      if (data.h5Show == 0 || (!data.signalPass && !data.backendCommission)) { 
        return false
      }
      if (data.validEndTime) {
        const now = moment()
        const validEndTime = moment(data.validEndTime)
        return now.isBefore(validEndTime)
      }
      return false
    },
    copyKLFn () {
      const data = this.curRow || {}
      let copyContent = this.isValid(data) ? `直播间：${data.liveRoomName}\n品类：${data.categoryName}\n品牌：${ data.brandName }\n失效时间：${ this.computedTime(data.validEndTime) }\n口令：${ this.extractUrls(data.signalPass) }\n爆品限时补贴至：${ data.userRebateStr || 0 }` 
          : `直播间：${data.liveRoomName}\n品类：${data.categoryName}品牌：${ data.brandName }\n选品库暂无有效口令。我现在需要，请工作人员尽快安排！谢谢！`
      copyFn(copyContent, () => {
        this.showCopyDialog = false
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      })
      addBuryingPoint.call(this, {
        type: 2,
        liveRoomId: data.liveRoomId || '',
        liveRoomName: data.liveRoomName || '',
        copyContent: JSON.stringify({
          mainImage: data.mainImage,
          liveRoomName: data.liveRoomName,
          productName: data.productName,
          copyContent
        }, false, false)
      })
    },
    computedTime (date) {
      if (date) {
        return moment(date).format('YYYY/MM/DD HH:mm:ss')
      }
      return '-'
    },
    checkResultCb(rst) {
      console.log('checkResult', rst)
      this.checkResult = rst
      this.showAddReportDialog = false
      this.showCheckResultDialog = true
    },

    showAddResultDialogHandler (rst) {
      this.showAddReportDialog = false
      this.importResult = rst
      this.showAddResultDialog = true
    },
    toOrder (row) {
      // this.curRow = row
      this.showAddReportDialog = true
    },
    toBuy (row) {
      this.curRow = row
      this.showBuyDrawer = true
    },
    copyContent (row) {
      this.curRow = row
      this.showCopyDialog = true
    },
    async getKlHotSearchWord () {
      const res = await getKlHotSearchWord.call(this)
      this.tags = (res || []).map(item => item.word)
    },
    copyLink () {
      const input = document.createElement('input')
      input.value = this.xlsxInfo.url
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message({
        message: '复制成功',
        type: 'success'
      })
      // this.showXlsxDialog = false
    },
    getUserPhone () {
      getLoginUserPhone.call(this).then(res => {
        this.phone = res
      })
    },
    async downloadHandler () {
      this.isDownloading = true
      this.downLoading = this.$loading({
        lock: true,
        text: '下载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.45)'
      })
      try {
        const data = await this.getAllList()
        this.makeExcel(data)
      } catch (error) {
        console.log(error)
        this.isDownloading = false
        this.downLoading && this.downLoading.close()
      }
    },
    getAllList () {
     return queryKlLiveRoomProductQdH5List.call(this)
    },
    extractUrls (text) {
      const urlRegex = /weixin?:\/\/[^\s]+/i;
      let match = text.match(urlRegex);
      if (match) {
        return match[0].trim()
      }
      return ''
    },
    makeExcel (list=[]) {
      const data = [
        ['直播间名称', '品类', '品牌', '爆品限时补贴至', '失效时间', '口令']
      ]
      list.forEach(item => {
        data.push([
          item.liveRoomName || '',
          item.categoryName || '',
          item.brandName || '',
          (item.userRebateStr || 0) + '',
          item.validEndTime ? moment(item.validEndTime).format('YYYY-MM-DD HH:mm:ss') : '',
          this.extractUrls(item.signalPass || '')
        ]) 
      })
      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet(data)

      // 创建工作簿并添加工作表
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

      // 生成Excel文件
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })

      // 使用blob和FileReader创建一个URL然后下载
      const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
      const filename = `M2S选品库${+new Date()}.xlsx`
      const file = new File([excelBuffer], filename, {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        lastModified: Date.now()
      });
      // const form = {
      //   media: file,
      //   path: `xpk-h5/${this.phone}`
      // }
      // console.log(form)
      // console.log(URL.createObjectURL(dataBlob))
      this.isDownloading = false
      this.downLoading && this.downLoading.close()
      // request.requestUploadFile(URL.createObjectURL(dataBlob), form, true).then(res => {
      //   if (res?.ossPath) {
      //     ossPath.value.ossPath = res.ossPath
      //     getPresignedUrl(res.ossPath)
      //   }
      // })
      const formData = new FormData()
      formData.append('media', file)
      formData.append('path', `xpk-h5/${this.phone}`)
      uploadImage.call(this, formData).then(resp => {
        this.xlsxInfo.url = resp.img
        this.xlsxInfo.time = moment().format('YYYY-MM-DD HH:mm:ss')
        this.showXlsxDialog = true
        addBuryingPoint.call(this, {
          type: 5, 
          copyContent: resp.img
        })
      }).finally(() => {
        this.downLoading && this.downLoading.close()
      })
    },

    init () {
      const history = window.localStorage.getItem('M2S_HISTORY_SEARCH')
      if (history) {
        this.historyList = JSON.parse(history)
      }
      this.$nextTick(() => this.checkHistoryOverflow())
      addBuryingPoint.call(this, {
        type: 1 // 1-登录 2-复制 3-搜索 5-下载口令
      })
      this.getUserPhone()
      this.queryKlProductCategoryPage()
      this.getBrandList()
      this.getKlHotSearchWord()
    },
    categoryClick(item) {
      this.form.categoryId = item.value
      this.form.brandName = ''
      this.getBrandList()
      this.getList()
    },
    brandClick(item) {
      this.form.brandName = item.value
      this.getList()
    },
    getList () {
       let opt = {
        pageIndex: this.pageInfo.pageIndex,
        pageSize: this.pageInfo.pageSize,
        orderByType: this.curSortType,
        requestSource: 2 // h5
      }
      // // 品类
      if (this.form.categoryId) {
        opt.categoryId = this.form.categoryId
      }
      if (this.form.brandName) {
        opt.brandName = this.form.brandName
      }
      this.isLoading = true 
      queryKlLiveRoomProductQdH5Page.call(this, opt).then(res => {
        const {records, total} = res
        this.list = [...(records || [])]
        this.pageInfo.total = total
      }).finally(() => {
        this.isLoading = false
      })
    },
    getBrandList () {
      getBrandList.call(this, {
        categoryId: this.form.categoryId
      }).then(res => {
        const records = res || []
        this.brandList = [{
          label: '全部',
          value: ''
        }]
        this.brandList = this.brandList.concat(records.map(item => ({
          label: item,
          value: item
        })))
      })
    },
    queryKlProductCategoryPage () {
      queryKlProductCategoryPage.call(this, {
        pageNum: 1,
        pageSize: 2000
      }).then(res => {
        const records = res.records || []
        this.categoryList = [{
          label: '全部',
          value: ''
        }]
        this.categoryList = this.categoryList.concat(records.map(item => ({
          label: item.categoryName,
          value: item.categoryId
        })))  
      })
    },
    exportData() {
      // 导出逻辑
      console.log('导出数据')
    },
    selectTag(tag) {
      this.toSearchPage(tag)
      // this.getList()
    },
    toSearch () {
      if (!this.keyword) {
        this.$message.warning('请输入搜索关键词')
        return
      }
      this.updateHistoryList(this.keyword)
      this.toSearchPage(this.keyword)
    },
    toSearchPage (keyword) {
      if (!keyword && !this.keyword) {
        this.$message.warning('请输入搜索关键词')
        return
      }
      this.$router.push({
        path: '/xpk/m2s/search',
        query: {
          keyword: keyword || this.keyword
        }
      })
    }
  }
}
</script>

<style scoped>
.search-main,
.tags-box {
  padding: 12px 0 0 0;
  width: 720px;
  margin: 0 auto;
}
.tags-box {
  color: #6A6A6A;
}
.tags-box .tag {
  cursor: pointer;
  font-size: 13px;
  margin-right: 12px;
}
.input-btn {
  border: solid 1px #F74EB5;
  padding: 1px;
  border-radius: 4px;
}
.input-btn ::v-deep .el-input__inner {
  border: none;
}
.input-btn .search-btn {
  padding: 0 12px;
  border: 1px solid;
  color: #fff;
  background: linear-gradient(270deg, #FF38B9 0%, #FF6F85 100%); 
}
.export-btn {
  padding: 0 12px;
  border: 1px solid #F74EB5;
  color: #fff;
  background-color: #F74EB5;
  margin-left: 12px;
}
.search-types {
  padding: 12px;
  padding-bottom: 0;
  background-color: #fff;
}
.search-types .type-line {
  display: flex;
  flex-wrap: wrap;
  line-height: 24px;
  margin-bottom: 12px;
}
.type-line .item {
  cursor: pointer;
  margin-right: 24px;
  font-size: 13px;
  color: #000;
}
.type-line .item.active,
.type-line .item:hover {
  font-weight: 600;
  color: #F74EB5;
}
.type-line2 { 
  position: relative;
  height: 24px;
  line-height: 24px;
  overflow: hidden;
  padding-right: 24px;
}
.type-line2.is-down {
  height: auto;
  overflow: hidden;
}
.type-line2 .down {
  cursor: pointer;
   position: absolute;
  top: 0px;
  right: 0px;
}
.type-line2 .item {
  margin-right: 16px;
  color: #6A6A6A;
}

.type-line2 .item.active,
.type-line2 .item:hover {
  font-weight: inherit;
  color: #F74EB5;
}
.line-tabs {
  cursor: pointer;
  display: flex;
  color: rgba(0, 0, 0, 0.6);
  position: relative;
  height: 24px;
  font-size: 14px;
  font-weight: 500x;
  line-height: 24px;
}
.line-tabs::after {
  content: '';
  position: absolute; 
  bottom: 1px;
  height: 1px;
  width: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.1);
}
.line-tabs .item {
  margin-right: 24px;
  position: relative;
}
.line-tabs .item.active,
.line-tabs .item:hover {
  color: #F74EB5;
}
.line-tabs .item.active::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
  border-radius: 3px;
  background-color: #F74EB5;
  z-index: 2;
}
.cards-container {
  padding: 16px 0;
  display: flex;
  flex-wrap: wrap;
}
.cards-container .item {
  width: calc((100% - (24px * 4)) / 5);
  margin: 0 24px 24px 0;
}
.cards-container .item:nth-child(5n) {
  margin-right: 0;
}
.page-pagination {
  text-align: center;
  padding-bottom: 24px;
}
.no-data {
  padding: 24px 0;
  text-align: center;
  font-size: 16px;
  color: #999;
}
.download-container {
  line-height: 22px;
  background-color: #fff;
}
.down-tip {
  border-bottom: solid 1px rgba(229, 229, 229, 1);
  padding-bottom: 12px;
  margin-bottom: 12px;
}
.copy-content {
  line-height: 24px;
}
.search-popver__title {
  line-height: 20px;
  color: rgba(47, 47, 47, 1);
  font-weight: 400;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.search-popver__content {
  padding: 6px 0 16px 0;
  display: flex;
  flex-wrap: wrap;
}
.search-popver__content .item {
  font-size: 12px;
  color: rgba(100, 100, 100, 1);
  border: solid 0.5px rgba(218, 218, 218, 1);
  line-height: 32px;
  padding: 0 12px;
  border-radius: 18px;
  margin: 0 16px 6px 0;
  cursor: pointer;
  transition: all 0.3s;
}
.search-popver__content .item:hover {
  background-color: #F74EB5;
  color: #fff;
}
.clear-btn {
  color: rgba(100, 100, 100, 1);
  font-size: 12px;
  cursor: pointer;
}
.clear-btn i {
  margin-right: 3px;
}
.clear-btn:hover {
  color: #F74EB5;
}
.clear-content {
  font-size: 16px;
  text-align: center;
  padding-bottom: 24px;
}
.history-content {
  position: relative;
  padding-right: 24px;
}
.history-content .history-items {
  display: flex;
  flex-wrap: wrap;
  max-height: 76px;
  overflow: hidden;
}
.history-content.is-expanded .history-items {
  max-height: none;
}
.history-content .expand-btn {
  position: absolute;
  right: -16px;
  bottom: 14px;
  cursor: pointer;
  font-size: 12px;
  color: rgba(100, 100, 100, 1);
  border: solid 0.5px rgba(218, 218, 218, 1);
  line-height: 32px;
  padding: 0 12px;
  border-radius: 18px;
  margin: 0 16px 6px 0;
  cursor: pointer;
  transition: all 0.3s;
}
.history-content .expand-btn:hover {
  background-color: #F74EB5;
  color: #fff;
}
</style>
